import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'minus-vertical', 'IconMinusVertical', [["path",{"d":"M12 5v14","key":"svg-0"}]]);